module.exports = __webpack_public_path__ + "img/9788989646723.b8c94620.jpg";